import { Injectable } from '@angular/core';
import { ProjectItem } from '../model';
import { BaseService } from '../../shared/baseService';

@Injectable({
    providedIn: 'root'
})

export class ProjectItemsService extends BaseService<ProjectItem> {
    constructor() {
        super('ProjectItem');
    }
}
